// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
  position: fixed;
  z-index: 11;
  width: 100%;
  height: 100%;
  top: 0%;
  left: 0;
  background-color: rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center; }
  .popup .popupContent {
    background-color: #fafafa;
    /* Popup background color */
    padding: 4rem;
    border-radius: 1rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    /* Box shadow for a raised effect */
    max-width: 42.2rem;
    /* Adjust the width as needed */
    width: 100%;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2); }
    .popup .popupContent .thank-you-popup {
      font-size: 3.4rem;
      text-align: center;
      transition: opacity 0.5s ease;
      /* Add a transition effect for opacity */ }
      .popup .popupContent .thank-you-popup .appear {
        opacity: 1;
        /* Change opacity to 1 when it should appear */ }
      .popup .popupContent .thank-you-popup h1 {
        font-weight: 400;
        font-size: 2rem; }
  .popup .popupTitle {
    font-size: 2.4rem;
    padding: 1rem 4rem 1rem 0; }
  .popup .fa-times {
    display: flex;
    justify-content: flex-end;
    font-size: 2rem;
    cursor: pointer; }
    .popup .fa-times::before {
      display: none; }

.choiceList {
  list-style: none;
  padding: 0; }
  .choiceList .listData {
    font-size: 1.4rem;
    padding: 0.8rem 0;
    cursor: pointer; }
    .choiceList .listData label {
      cursor: pointer; }
    .choiceList .listData input {
      margin-right: 1rem;
      cursor: pointer; }

.errorContainer {
  gap: 15px;
  margin: 3rem auto 1rem;
  display: flex;
  flex-direction: column; }
  .errorContainer .showError {
    color: red;
    font-size: 13px; }
  .errorContainer .submitBtn {
    background-color: #1a0dab;
    text-align: center;
    border: none;
    padding: 1.2rem 2.4rem;
    border-radius: 0.5rem;
    font-weight: 700;
    color: white;
    display: flex;
    font-size: 1.4rem;
    cursor: pointer;
    width: 100px;
    align-items: center;
    margin: auto; }
`, "",{"version":3,"sources":["webpack://./src/components/AdPopup/AdPopup.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,OAAO;EACP,OAAO;EACP,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;EAVzB;IAaI,yBAAyB;IAAE,2BAAA;IAC3B,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IAAE,mCAAA;IACzC,kBAAkB;IAAE,+BAAA;IACpB,WAAW;IACX,0CAA0C,EAAA;IAnB9C;MAqBM,iBAAiB;MACjB,kBAAkB;MAClB,6BAA6B;MAAE,wCAAA,EAAyC;MAvB9E;QAyBQ,UAAU;QAAE,8CAAA,EAA+C;MAzBnE;QA4BQ,gBAAgB;QAChB,eAAe,EAAA;EA7BvB;IAkCI,iBAAiB;IACjB,yBAAyB,EAAA;EAnC7B;IAuCI,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,eAAe,EAAA;IA1CnB;MA4CM,aAAa,EAAA;;AAInB;EACE,gBAAgB;EAChB,UAAU,EAAA;EAFZ;IAII,iBAAiB;IACjB,iBAAiB;IACjB,eAAe,EAAA;IANnB;MAQM,eAAe,EAAA;IARrB;MAWM,kBAAkB;MAClB,eAAe,EAAA;;AAIrB;EACE,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,sBAAsB,EAAA;EAJxB;IAMI,UAAU;IACV,eAAe,EAAA;EAPnB;IAUI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,YAAY,EAAA","sourcesContent":[".popup {\n  position: fixed;\n  z-index: 11;\n  width: 100%;\n  height: 100%;\n  top: 0%;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .popupContent {\n    background-color: #fafafa; /* Popup background color */\n    padding: 4rem;\n    border-radius: 1rem;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Box shadow for a raised effect */\n    max-width: 42.2rem; /* Adjust the width as needed */\n    width: 100%;\n    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n    .thank-you-popup {\n      font-size: 3.4rem;\n      text-align: center;\n      transition: opacity 0.5s ease; /* Add a transition effect for opacity */\n      .appear {\n        opacity: 1; /* Change opacity to 1 when it should appear */\n      }\n      h1 {\n        font-weight: 400;\n        font-size: 2rem;\n      }\n    }\n  }\n  .popupTitle {\n    font-size: 2.4rem;\n    padding: 1rem 4rem 1rem 0;\n  }\n\n  .fa-times {\n    display: flex;\n    justify-content: flex-end;\n    font-size: 2rem;\n    cursor: pointer;\n    &::before {\n      display: none;\n    }\n  }\n}\n.choiceList {\n  list-style: none;\n  padding: 0;\n  .listData {\n    font-size: 1.4rem;\n    padding: 0.8rem 0;\n    cursor: pointer;\n    label {\n      cursor: pointer;\n    }\n    input {\n      margin-right: 1rem;\n      cursor: pointer;\n    }\n  }\n}\n.errorContainer {\n  gap: 15px;\n  margin: 3rem auto 1rem;\n  display: flex;\n  flex-direction: column;\n  .showError {\n    color: red;\n    font-size: 13px;\n  }\n  .submitBtn {\n    background-color: #1a0dab;\n    text-align: center;\n    border: none;\n    padding: 1.2rem 2.4rem;\n    border-radius: 0.5rem;\n    font-weight: 700;\n    color: white;\n    display: flex;\n    font-size: 1.4rem;\n    cursor: pointer;\n    width: 100px;\n    align-items: center;\n    margin: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
